import StopOutlined from '@ant-design/icons/StopOutlined'
import { Button, Input, InputRef } from 'antd'
import debounce from 'lodash/debounce'
import {
  Dispatch,
  FC,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import styled from 'styled-components'

const TextFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`

export const TextFilterDropdown: FC<{
  filterValue: string | undefined
  setFilterValue: Dispatch<SetStateAction<string | undefined>>
}> = ({ filterValue, setFilterValue: _setFilterValue }) => {
  const [internalFilterValue, setInternalFilterValue] = useState<
    string | undefined
  >(undefined)

  // Debounce it so we don't end up triggering a query
  // for every key press
  const setFilterValueDebounced = useMemo(
    () => debounce(_setFilterValue, 500),
    [_setFilterValue]
  )
  useEffect(() => {
    setFilterValueDebounced(internalFilterValue)
  }, [setFilterValueDebounced, internalFilterValue])
  useEffect(() => {
    setInternalFilterValue(filterValue)
  }, [filterValue])
  const inputRef = useRef<InputRef>(null)
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])
  const clearValue = useCallback(() => setInternalFilterValue(undefined), [])
  return (
    <TextFilterContainer>
      <Input
        ref={inputRef}
        placeholder='Search name'
        value={internalFilterValue}
        onChange={(e) => setInternalFilterValue(e.target.value)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      {!!filterValue && (
        <Button
          shape='circle'
          size='small'
          disabled={!filterValue}
          onClick={clearValue}>
          <StopOutlined />
        </Button>
      )}
    </TextFilterContainer>
  )
}
